export const POLICYTEXT = "By signing in, you agree to nurture’s";
export const ACCOUNT = "Don't have an account?";
export const SIGNUP = " Sign Up";
export const FORGETPASSWORD = "Forgot password?";
export const SIGNIN = "Sign In";
export const TERMS = "Terms of Service";
export const PRIVACY = "Privacy Policy";
